'use client';

import { SmartFormBlock } from '@/components/forms/SmartFormBlock/SmartFormBlock';

type CallUs = {
  content: string;
  styles: Record<string, string>;
};

export default function SubmitComplaintForm({ callUs }: { callUs: CallUs }) {
  return (
    <SmartFormBlock
      formId="submitComplaint"
      mode="inline"
      template="bare"
      submitLabel="Submit"
      columns={2}
      metadata={{
        pageType: 'complaint',
        source: 'submit-complaint-page',
      }}
      renderFooterExtra={() => (
        <p className={`${callUs.styles.p} w-full md:hidden`}>
          {callUs.content}
        </p>
      )}
      buttonContainerClassName="flex flex-col md:flex-row items-center gap-4 pt-1"
    />
  );
}
